export const LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  GET_ACCESS_AND_REFRESH_TOKEN = "GET_ACCESS_AND_REFRESH_TOKEN",
  LOGIN2FA = "LOGIN2FA",
  IMPERSONATE_TENANT="IMPERSONATE_TENANT";